import React, { useState } from "react";
import { Turn } from "hamburger-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { navbarItems } from "../utils/navbarItems";

import classes from "./HamburgerMenu.module.css";

const HamburgerMenu = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  if (open) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return (
    <div className={classes["wrapper"]}>
      <Turn toggled={open} toggle={setOpen} />
      <div
        style={open ? { transform: "translateX(0)" } : null}
        className={classes["hamburger"]}
      >
        <div className={classes["nav-items"]}>
          {navbarItems.map((item) => {
            return (
              <a
                key={item.id}
                onClick={() => setOpen(() => false)}
                href={item.path}
                className={classes["item"]}
              >
                {item.title}
              </a>
            );
          })}
        </div>
        <button
          onClick={() => navigate("/login")}
          className={classes["login-button"]}
        >
          {t("Login")}
        </button>
      </div>
    </div>
  );
};

export default HamburgerMenu;
